import "./OrderHistoryModal.css";

const OrderHistoryModal = ({
  open,
  onClose,
  restaurantName,
  orders,
  loading,
}) => {
  if (!open) return null;

  return (
    <div className="loyalty-modal-overlay" onClick={onClose}>
      <div
        className="loyalty-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="loyalty-modal-header">
          <h3>{restaurantName} – Orders</h3>
          <button className="loyalty-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="loyalty-modal-body">
          {loading ? (
            <div className="loader">Loading orders...</div>
          ) : orders?.length > 0 ? (
            <table className="loyalty-orders-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Earned Points</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order, index) => (
                  <tr key={index}>
                    <td>{order.orderId}</td>
                    {/* <td>{order.points}</td> */}
                    <td>
                      {order.points > 0 ? `+${order.points}` : order.points}
                    </td>
                    {/* <td>{new Date(order.creationDate).toLocaleString()}</td> */}
                    <td>
                      {" "}
                      {new Date(order.creationDate).toLocaleString("en-US", {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No orders found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderHistoryModal;
